import {QEPSystemType} from '@qep/types/src';

export function getQepSystem(): QEPSystemType {
  if (globalThis.QEP === undefined) {
    throw new TypeError('QEP not initialized');
  }

  return globalThis.QEP;
}
